
window.productCardTitleLines = window.productCardTitleLines || ((e) => {
  //console.log('running',e);
  const MQ_DESKTOP = "(min-width:1200px)";
  const MQ_L_DESKTOP = "(min-width:700px)";
  const CLS = "title-double-line";
  const LIST_S = '.product-list';
  const TITLE_H = 16;

  const perRow = (list, matchedMedia) => {
    //console.log('per-row');
    const cs = getComputedStyle(list);
    const v = matchedMedia === MQ_DESKTOP ? (cs.getPropertyValue("--card-grid-per-row") || "").trim() : (cs.getPropertyValue("--card-grid-per-row-lower-desktop") || "").trim();
    const n = parseInt(v, 10);
    //console.log('var: ',Number.isFinite(n) && n > 0);
    return Number.isFinite(n) && n > 0 ? n : 3;
  };

  const apply = (root = document) => {
    //console.log('apply');
    let matchedMedia;
    if (matchMedia(MQ_DESKTOP).matches){
      matchedMedia = MQ_DESKTOP;
    }else if (matchMedia(MQ_L_DESKTOP).matches) {
      matchedMedia = MQ_L_DESKTOP;
    }
    if (!matchedMedia) return;

    const lists = root.querySelectorAll(LIST_S);
    if (!lists.length) return

    lists.forEach(list => {
      //console.log(list, [...list.querySelectorAll("product-card")]);
      const cards = [...list.querySelectorAll("product-card")].filter(c => c.clientWidth > 0);
      if (!cards.length) return;

      const n = perRow(list,matchedMedia);
      //console.log({perRow: n, card_length: cards.length});
      if (!n) return;

      for (let i = 0; i < cards.length; i += n) {
        const row = cards.slice(i, i + n);
        //console.log('tocheck: ',row)
        row.forEach(c => c.classList.remove(CLS));
        const exceedingHeight = row.some(c => (c.querySelector(".product-card__title a").offsetHeight > TITLE_H));
        if (exceedingHeight) {
          row.forEach(c => c.classList.add(CLS));
        }
      }
    });
    //console.log('running apply end')
  };

  let raf = 0, lastRoot = document;
  const schedule = (root = document) => {
    //console.log('schedule start')
    lastRoot = root;
    if (raf) return;
    raf = requestAnimationFrame(() => (raf = 0, apply(lastRoot)));
    //console.log('schedule end')
  };

  window.applyTitleDoubleLine = schedule;

  const kick = () => schedule(document);

  addEventListener("resize", kick, { passive: true });
  addEventListener("shopify:section:load", e => schedule(e.target));
  addEventListener("shopify:section:reorder", e => schedule(e.target));

  kick();
});
addEventListener('product-grid-reveal', function(e){
  const reveal = e?.detail?.reveal;
  if (!reveal?.finished) {
    productCardTitleLines(e);
    return;
  }

  reveal.finished.then(() => {
    productCardTitleLines(e);
  });
});

  